export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2D2920] text-white/80 py-16"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_land-marketplace-27/artifacts/dsh5mmu4_Ima%CC%81genes%20Meli%20Walmart%20Elektra%20-%20Easyliving%20-%20Nuevo%20Disen%CC%83o%20-%20Alex.png"
                alt="Real San José Residencial"
                className="h-14 w-14 object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <div className="leading-tight">
                <div className="font-heading text-lg tracking-[0.18em] text-white">
                  REAL SAN JOSÉ
                </div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/60">
                  Residencial
                </div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-xs font-light">
              Fraccionamiento desarrollado por <span className="text-white">Lauburu</span>.
              Lotes residenciales listos para construir, con infraestructura
              urbana de primer nivel.
            </p>
          </div>

          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#C9B68A] font-medium">
              Navegación
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              <li><a href="#features" className="hover:text-white transition-colors">Características</a></li>
              <li><a href="#gallery" className="hover:text-white transition-colors">Galería</a></li>
              <li><a href="#location" className="hover:text-white transition-colors">Ubicación</a></li>
              <li><a href="#contact" className="hover:text-white transition-colors">Contacto</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-[#C9B68A] font-medium">
              Contacto
            </div>
            <ul className="mt-4 space-y-2 text-sm font-light">
              <li>WhatsApp: 392 100 3836</li>
              <li>realsanjose@lauburu.mx</li>
              <li>Visitas con cita previa</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} Real San José Residencial · Desarrollado por Lauburu. Todos los derechos reservados.</div>
          <div className="tracking-[0.25em] uppercase">Hecho con cuidado, para tu hogar</div>
        </div>
      </div>
    </footer>
  );
}
